import { Component } from '@angular/core'; 
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { STATIC_VALUE } from './../../shared/configuration/static.value';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { ProfileService } from '../services/profile.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'profile-update-profile',
    templateUrl: 'update-profile.component.html'
})
export class ProfileUpdateProfileComponent{

    vUserid: number;
    sub: any;
    constructor(
        private _profileService: ProfileService,
        private _layoutService: LayoutService, 
        private _errorService: ErrorService,
        private _popupService: PopupService,
        private _activatedRoute: ActivatedRoute,
        private _location: Location
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('profile-update-profile');
        this._profileService.resetError();
        this._profileService.resetProfileData();
        this._profileService.loadUserProfile();
    }

    openChangePassword(){
        this._popupService.openPopup( 'change-password', {
            title: 'Change Password',
            buttons: {
                CANCEL: {
                    text: 'Cancel',
                    function: () => {
                        this._popupService.closePopup();
                    }
                },
                OK: {
                    text: 'Save',
                    function: () => {
                        this._profileService.changePassword();
                    }
                }
            }
        } );
    }

    openChangeSecurityQuestion(){
        this._popupService.openPopup( 'change-security-question', {
            title: 'Change Security Question',
            buttons: {
                CANCEL: {
                    text: 'Cancel',
                    function: () => {
                        this._popupService.closePopup();
                    }
                },
                OK: {
                    text: 'Save',
                    function: () => {
                        this._profileService.changeSecurity();
                    }
                }
            }
        } );
    }
    
    getUserProfileData(){
        return this._profileService.getUserProfileData();
    }

    isDisableUpdateProfile(){
        return this._profileService.isDisableUpdateProfile();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    isLoading(){
        return this._profileService.isLoading();
    }

    cancel(){
        this._location.back();
    }

    updateAccount(){
        this._profileService.updateUserProfile();
    }
    registertype()
    {
        if (this._profileService.getUserProfileData().registration_type == 'F')
        {
            return false;
        }
        else{
            return true;
        }
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/profile/components/update-profile.component.ts